import React, { useState, useRef } from 'react';
import './Accordion.css';

function DownloadAndInstructions() {
  const [openAccordion, setOpenAccordion] = useState(null);
  const [isDownloaded, setIsDownloaded] = useState(false);
  const [issueDescription, setIssueDescription] = useState('');
  const [screenshot, setScreenshot] = useState(null);
  const [preview, setPreview] = useState(null);

  const fileInputRef = useRef(null);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = `${process.env.PUBLIC_URL}/myscript.js`;
    link.download = 'myscript.js';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setIsDownloaded(true);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setScreenshot(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmitIssue = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('description', issueDescription);
    formData.append('screenshot', screenshot);

    try {
      const response = await fetch('https://abc.com', {
        method: 'POST',
        body: formData
      });
      if (response.ok) {
        alert('Issue submitted successfully');
        setIssueDescription('');
        setScreenshot(null);
        setPreview(null);
      } else {
        alert('Failed to submit issue');
      }
    } catch (error) {
      alert('Error submitting issue');
    }
  };

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  return (
    <div className="accordion">
      <div className="accordion-item">
        <input type="checkbox" id="accordion-1" checked={openAccordion === 1} readOnly />
        <label htmlFor="accordion-1" className="accordion-label" onClick={() => toggleAccordion(1)}>Download Script</label>
        <div className="accordion-content">
          {openAccordion === 1 && <DownloadComponent handleDownload={handleDownload} />}
        </div>
      </div>
      <div className="accordion-item">
        <input type="checkbox" id="accordion-2" checked={openAccordion === 2} readOnly />
        <label htmlFor="accordion-2" className="accordion-label" onClick={() => toggleAccordion(2)}>Instructions</label>
        <div className="accordion-content">
          {openAccordion === 2 && <InstructionsComponent />}
        </div>
      </div>
      <div className="accordion-item">
        <input type="checkbox" id="accordion-3" checked={openAccordion === 3} readOnly />
        <label htmlFor="accordion-3" className="accordion-label" onClick={() => toggleAccordion(3)}>Report an Issue</label>
        <div className="accordion-content">
          {openAccordion === 3 && <ReportIssueComponent 
                                      issueDescription={issueDescription}
                                      setIssueDescription={setIssueDescription}
                                      handleFileChange={handleFileChange}
                                      handleSubmitIssue={handleSubmitIssue}
                                      fileInputRef={fileInputRef}
                                      preview={preview} />}
        </div>
      </div>

      <div className="accordion-item">
        <input type="checkbox" id="accordion-4" checked={openAccordion === 4} readOnly />
        <label htmlFor="accordion-4" className="accordion-label" onClick={() => toggleAccordion(4)}>Choose Settings</label>
        <div className="accordion-content">
          {openAccordion === 4 && <ChoosenSettings />}
        </div>
      </div>
    </div>
  );
}

const DownloadComponent = ({ handleDownload }) => (
  <div>
    <button onClick={handleDownload} className="download-button">Download Script</button>
  </div>
);

const InstructionsComponent = () => (
  <div className="instructions">
    <h2>Instructions</h2>
    <div className="step">
      <h3>Step 1</h3>
      <p>Kindly attach the downloaded script in the head of your HTML page of the site.</p>
      <p>Before:</p>
      <pre>
        <code>
          {`<!DOCTYPE html>
<html>
<head>
  <title>My Website</title>
  <!-- Other head elements -->
</head>
<body>
  <!-- Body content -->
</body>
</html>`}
        </code>
      </pre>
      <p>After:</p>
      <pre>
        <code>
          {`<!DOCTYPE html>
<html>
<head>
  <title>My Website</title>
  <!-- Other head elements -->
  <script src="path/to/myscript.js"></script>
</head>
<body>
  <!-- Body content -->
</body>
</html>`}
        </code>
      </pre>
    </div>
    <div className="step">
      <h3>Step 2</h3>
      <p>Please pass the credentials correctly to the script.</p>
    </div>
  </div>
);

const ReportIssueComponent = ({ issueDescription, setIssueDescription, handleFileChange, handleSubmitIssue, fileInputRef, preview }) => (
  <form onSubmit={handleSubmitIssue} className="report-form">
    <h2>Report an Issue</h2>
    <div>
      <label htmlFor="description">Description</label>
      <textarea
        id="description"
        value={issueDescription}
        onChange={(e) => setIssueDescription(e.target.value)}
        required
      ></textarea>
    </div>
    <div>
      <label htmlFor="screenshot">Screenshot</label>
      <input
        type="file"
        id="screenshot"
        accept="image/*"
        onChange={handleFileChange}
        ref={fileInputRef}
      />
      {preview && (
        <div className="image-preview">
          <img src={preview} alt="Screenshot Preview" />
        </div>
      )}
    </div>
    <button type="submit" className="submit-button">Submit Issue</button>
  </form>
);

const ChoosenSettings = () => {
  const [requestsSetting, setRequestsSetting] = useState('cloud');
  const [authSetting, setAuthSetting] = useState('cloud');

  const handleRequestsChange = (event) => {
    setRequestsSetting(event.target.value);
  };

  const handleAuthChange = (event) => {
    setAuthSetting(event.target.value);
  };

  return (
    <div>
      <h2>Choosen Settings</h2>
      
      <div>
        <h3>Requests</h3>
        <div>
          <label>
            <input
              type="radio"
              value="local"
              checked={requestsSetting === 'local'}
              onChange={handleRequestsChange}
            />
            Locally Managed
          </label>
          <label>
            <input
              type="radio"
              value="cloud"
              checked={requestsSetting === 'cloud'}
              onChange={handleRequestsChange}
            />
            Cloud Managed
          </label>
        </div>
      </div>

      <div>
        <h3>Authentication</h3>
        <div>
          <label>
            <input
              type="radio"
              value="local"
              checked={authSetting === 'local'}
              onChange={handleAuthChange}
            />
            Locally Managed
          </label>
          <label>
            <input
              type="radio"
              value="cloud"
              checked={authSetting === 'cloud'}
              onChange={handleAuthChange}
            />
            Cloud Managed
          </label>
        </div>
      </div>
    </div>
  );
};

export default DownloadAndInstructions;
